import type { MittwaldApi } from "../../api/Mittwald";
import { mittwaldApi } from "../../api/Mittwald";

export type BackupApiData =
  MittwaldApi.Components.Schemas.De_Mittwald_V1_Backup_ProjectBackup;

export class Backup {
  public readonly id: string;
  public readonly data: BackupApiData;

  private constructor(data: BackupApiData) {
    this.id = data.id;
    this.data = Object.freeze(data);
  }

  public static fromApiData(data: BackupApiData): Backup {
    return new Backup(data);
  }

  public static useLoadById(backupId: string): Backup {
    const data = mittwaldApi.backupGetProjectBackup
      .getResource({ path: { projectBackupId: backupId } })
      .useWatchData();
    return Backup.fromApiData(data);
  }

  public static useTryLoadById(backupId?: string): Backup | undefined {
    const data = mittwaldApi.backupGetProjectBackup
      .getResource(backupId ? { path: { projectBackupId: backupId } } : null)
      .useWatchData({ optional: true });
    return data ? Backup.fromApiData(data) : undefined;
  }
}

export default Backup;
